import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectFade,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import axios from "axios";
import { Link } from "react-router-dom";

function BannerFive() {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("https://solanthegroup.com/admin/api/sliders")
      .then((response) => {
        setSliders(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Failed to load sliders");
        setLoading(false);
      });
  }, []);

  if (loading) return <p></p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div>
      {/* Startup banner swiper main wrapper */}
      <div className="startup-banner-swiper-wrapper">
        <div className="swiper swiper-startup-banner">
          <Swiper
            modules={[Navigation, Pagination, EffectFade, Scrollbar, A11y, Autoplay]}
            className="swiper-startup-banner"
            speed={500}
            slidesPerView={1}
            spaceBetween={0}
            loop={true}
            autoplay={{
              delay: 5500,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{ clickable: true }}
          >
            {sliders.map((slide) => (
              <SwiperSlide key={slide.id}>
                {/* Banner area start */}
                <div
                  className="tmp-banner-area banner-style-five tmp-section-gap bg_image"
                  style={{
                    backgroundImage: `url(https://solanthegroup.com/admin/${slide.photo})`,
                    position: "relative",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: '100%',
                    height: '100vh'
                  }}

                >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="banner-startup-main-content-wrapper">
                          <h1 className="title">
                            {slide.first_title} <br /> {slide.second_title}
                          </h1>
                          <p className="disc">{slide.description}</p>
                          {slide.button_text &&
                          <Link to={slide.button_link} className="tmp-btn btn-primary">
                            {slide.button_text}
                          </Link>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Banner area end */}
              </SwiperSlide>
            ))}

            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </Swiper>
        </div>
      </div>
      <style>{`
        .bg_image::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #00000075; 
        }
        .swiper-button-prev,.swiper-button-next{
          display:none !important;
        }
      `}</style>
    </div>
  );
}

export default BannerFive;
